// src/index.js - Version corrigée
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { Provider } from 'react-redux';
import './styles/index.scss';
import { FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';
import { AuthProvider } from './context/authProvider';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Nettoyer les anciens service workers AVANT d'en enregistrer de nouveaux
const cleanupServiceWorkers = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();

      // Supprimer tous les anciens service workers
      for (let registration of registrations) {
        await registration.unregister();
      }

      console.log('Service workers nettoyés');
    } catch (error) {
      console.log('Erreur lors du nettoyage des service workers:', error);
    }
  }
};

// Nettoyer puis enregistrer
cleanupServiceWorkers().then(() => {
  // Enregistrer le nouveau service worker après nettoyage
  serviceWorkerRegistration.register({
    onUpdate: registration => {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        // window.location.reload();
      }
    }
  });
});

ReactDOM.render(
  <AuthProvider>
    <Provider store={store}>
      <GoogleReCaptchaProvider reCaptchaKey="6LfjOt0pAAAAAFcEvh1DMhOaK2d-2f5o-J3Wa_cc">
        <App />
      </GoogleReCaptchaProvider>
    </Provider>
  </AuthProvider>,
  document.getElementById('root')
);

reportWebVitals();
